"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEquivalentInstallationFile = IsEquivalentInstallationFile;
exports.IsEquivalentInstallation = IsEquivalentInstallation;
exports.InstallToStrings = InstallToStrings;
exports.looksLikeRuntimeVersion = looksLikeRuntimeVersion;
exports.GetDotnetInstallInfo = GetDotnetInstallInfo;
const InstallIdUtilities_1 = require("../Utils/InstallIdUtilities");
/**
 *
 * @returns True if the underlying installs are the exact same 'files'.
 * An 'install' is technically marked on disk by its install id.
 * The id could theoretically be temporarily shared between installs that are not the same underlying files.
 * For example, if the install id becomes '8', then '8' could at one point hold 8.0.100, then later 8.0.200.
 * That is not the case at the moment, but it is a possibility.
 * Think carefully between using this and IsEquivalentInstallation
 */
function IsEquivalentInstallationFile(a, b) {
    return a.version === b.version && a.architecture === b.architecture &&
        a.isGlobal === b.isGlobal && a.installMode === b.installMode;
}
/**
 *
 * @returns true if A and B are can be treated as the same install.
 * This does not mean they have the same files on disk or version, just that they should be managed as the same install.
 * (e.g. auto updating the '8.0' install.)
 * Think carefully between using this and IsEquivalentInstallationFile. There is no difference between the two *yet*
 */
function IsEquivalentInstallation(a, b) {
    return a.installId === b.installId;
}
/**
 * @returns A string set representing the installation of either a .NET runtime or .NET SDK.
 */
function InstallToStrings(install) {
    var _a;
    return {
        installId: install.installId,
        version: install.version,
        architecture: (_a = install.architecture) !== null && _a !== void 0 ? _a : 'unspecified',
        isGlobal: install.isGlobal.toString(),
        installMode: install.installMode.toString()
    };
}
function looksLikeRuntimeVersion(version) {
    var _a, _b;
    const band = (_a = version.split('.')) === null || _a === void 0 ? void 0 : _a[2];
    return ((_b = band === null || band === void 0 ? void 0 : band.length) !== null && _b !== void 0 ? _b : 0) <= 2; // assumption : there exists no runtime version at this point over 99 sub versions
}
function GetDotnetInstallInfo(installVersion, installationMode, installType, installArchitecture) {
    return {
        installId: (0, InstallIdUtilities_1.getInstallIdCustomArchitecture)(installVersion, installArchitecture, installationMode, installType),
        version: installVersion,
        architecture: installArchitecture,
        isGlobal: installType === 'global',
        installMode: installationMode,
    };
}
//# sourceMappingURL=DotnetInstall.js.map